import { SVG } from 'components/Asset/SVG';
import { LinkButton } from 'components/Buttons/LinkButton';
import { FlexBox } from 'components/Containers/FlexBox';
import { useState } from 'react';
import { CreateExternalUserModal } from './components/modals/CreateExternalUserModal';
import { ExternalUsersList } from './components/ExternalUserList';
import StyledSwitchButton from 'components/Buttons/SwitchButton';
import { FormControlLabel } from '@mui/material';
import { useAppSelector } from 'store/hook';
import { isExternalUser } from 'utils/validators/role.validation';
import { isDarkTheme } from 'utils/theme';
import { ThemePalette } from 'mui.theme';
import { useTranslation } from 'react-i18next';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

export const ExternalUserView = () => {
  const { t } = useTranslation();
  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false);
  const [showInactiveUsers, setShowInactiveUsers] = useState(true);

  const { role } = useAppSelector((state) => state.authReducer);
  const theme = useAppSelector((state) => state.authReducer).customer.theme;
  const enableDarkTheme = isDarkTheme(theme);
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  // if the user is an external user, disable certain fields
  const isDisabled = isExternalUser(role);

  return (
    <>
      {isAddUserModalOpen && (
        <CreateExternalUserModal
          key={`${isAddUserModalOpen.toString()}-create-user-modal`}
          open={isAddUserModalOpen}
          handleAbort={() => {
            setIsAddUserModalOpen(false);
          }}
          title={t('add_a_new_user')}
          enableDarkTheme={enableDarkTheme}
        />
      )}

      <FlexBox
        sx={{
          width: '100%',
          justifyContent: 'space-between',
        }}
      >
        <div></div>
        <FlexBox>
          <FlexBox
            sx={{
              display: 'flex',
              marginRight: '2rem',
            }}
          >
            <FormControlLabel
              control={<StyledSwitchButton />}
              label={t('show_inactive_users')}
              labelPlacement="start"
              checked={showInactiveUsers}
              onChange={() => {
                // Flip the value
                setShowInactiveUsers((last) => !last);
              }}
              sx={{
                color: enableDarkTheme
                  ? ThemePalette.typography.wheat
                  : ThemePalette.typography.black,
              }}
            />
          </FlexBox>
          <FlexBox
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <SVG
              name={isDisabled ? 'addDisabled' : 'add'}
              style={{ marginRight: '10px' }}
              onClick={() => {
                // open modal
                setIsAddUserModalOpen(true);
              }}
            />

            <LinkButton
              onClick={() => {
                // open modal
                setIsAddUserModalOpen(true);
              }}
              isDisabled={isDisabled}
              color={
                enableDarkTheme
                  ? ThemePalette.typography.wheat
                  : ThemePalette.typography.primary
              }
            >
              {t('add_a_new_user')}
            </LinkButton>
          </FlexBox>
        </FlexBox>
      </FlexBox>
      <ExternalUsersList showInactiveUsers={showInactiveUsers} />
    </>
  );
};
